"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const overview_1 = __importDefault(require("../../../templates/teamSettings/overview"));
const useTeamsState_1 = require("./hooks/useTeamsState");
const propertyKey = appConstants_1.companyPropertyKeys.requestLimit;
const TeamSettingsOverviewPage = () => {
    const { setHasChanges, setPageLoading } = (0, zustandStore_1.useZustand)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const { data: selectedTeamDetails } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamQuery)({ teamId: teamId?.[0] || '' }),
    });
    const { data: requestLimitData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.getRequestLimitQuery)(),
        initialData: initialData.requestLimitData,
    });
    const state = (0, useTeamsState_1.useTeamsState)();
    const saveTeamName = (0, teamQuery_1.useSaveTeamNameQuery)();
    const saveTeamProperty = (0, teamQuery_1.useSaveTeamPropertyQuery)();
    const [userCount, setUserCount] = (0, react_1.useState)({
        teamAdmin: 0,
        teamManager: 0,
        teamMember: 0,
    });
    (0, react_1.useEffect)(() => {
        if (selectedTeamDetails) {
            state.setTeam(selectedTeamDetails);
        }
    }, [state.setTeam, selectedTeamDetails]);
    (0, react_1.useEffect)(() => {
        if (userData) {
            state.setUser(userData);
            state.setCompanyName(userData.companyName);
            state.setCompanyId(userData.companyAccountId);
        }
    }, [state.setCompanyId, state.setCompanyName, state.setUser, userData]);
    (0, react_1.useEffect)(() => {
        if (requestLimitData) {
            state.setCompanyProperty({
                key: propertyKey,
                value: lodash_1.default.isObject(requestLimitData) ? '' : lodash_1.default.toNumber(requestLimitData),
            });
        }
    }, [requestLimitData, state.setCompanyProperty]);
    (0, react_1.useEffect)(() => {
        if (state.team?.name) {
            const teamName = state.team.name || '';
            state.setTeamName(teamName);
            state.setInitialTeamName(teamName);
            state.setHeaderName(teamName);
            getUserCounts();
        }
    }, [state.setHeaderName, state.setTeamName, state.team?.name]);
    const getUserCounts = () => {
        const counts = {
            admin: 0,
            manager: 0,
            member: 0,
        };
        if (state.team?.users) {
            for (const user of state.team.users) {
                counts.admin += user?.roles.filter(role => role.roleId === appConstants_1.teamRoleConstants.TEAM_ADMIN && state.team?.id === role.securityGroupId).length;
                counts.manager += user?.roles.filter(role => role.roleId === appConstants_1.teamRoleConstants.TEAM_MANAGER && state.team?.id === role.securityGroupId).length;
                counts.member += user?.roles.filter(role => role.roleId === appConstants_1.teamRoleConstants.TEAM_MEMBER && state.team?.id === role.securityGroupId).length;
            }
        }
        setUserCount({
            teamAdmin: counts.admin,
            teamManager: counts.manager,
            teamMember: counts.member,
        });
    };
    const onSaveChanges = () => {
        setPageLoading(true);
        if (!state.team) {
            return;
        }
        const teamDetails = {
            ...state.team,
            properties: {
                ...state.team?.properties,
                [appConstants_1.teamFeaturesConstants.requestLimit]: state.currentTeam.teamRequestLimit,
            },
        };
        state.setTeam(teamDetails);
        const teamFeatures = Object.values(appConstants_1.teamFeaturesConstants);
        for (const item of teamFeatures) {
            if (teamDetails.properties[item] !== teamFeatures[item]) {
                saveTeamProperty.mutate({
                    teamId: teamDetails.id,
                    propertyKey: item,
                    propertyValue: teamDetails.properties[item],
                });
            }
        }
        saveTeamName.mutate({ teamId: teamDetails.id || '', teamName: state.teamName }, {
            onSuccess: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: strings_1.teamSettingsOverviewStrings.SAVE_TEAM_SUCCESS_MESSAGE,
                    },
                ]);
                setHasChanges(false);
            },
            onError: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.errorStrings.DEFAULT
                            : strings_1.teamSettingsOverviewStrings.SAVE_TEAM_WARNING_MESSAGE,
                    },
                ]);
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(overview_1.default, { userCount: userCount, onSaveChanges: onSaveChanges })] }));
};
exports.default = TeamSettingsOverviewPage;
